const pages = [
  {
    path: '/manutencao',
    name: 'manutencao',
    component: () => import('@/components/acesso/TelaEmManutencao.vue'),
    meta: {
      layout: 'content',
      id: 1,
    },
  },
  {
    path: '/nao-autorizado',
    name: 'nao-autorizado',
    component: () => import('@/components/acesso/AcessoNegado.vue'),
    meta: {
      layout: 'content',
      id: 2,
    },
  },
]

export default pages
